<template>

	<div v-if="showDetailsShell" class="mx-auto p-3 sm:p-4">
		<div class="mx-auto">
			<div ref="detailsContent" id="detailsContent" class="text-gray-700">
				<div v-if="!hideDetailsHeaderInEmbeddedModal" class="btn-grup flex justify-between border-b mb-3 pb-3">
					<div class="flex items-center gap-3">
						<button
							class="flex flex-row hover:bg-gray-4 items-center rounded py-2 px-4 text-center font-sans mr-2 text-xs font-bold hover:text-primary-500 transition-all bg-transparent border-gray-3 border text-primary"
							type="button"
							@click="handleBackButtonClick"
						>
							<i class="tabler:arrow-left w-5 h-5 mr-1"></i>
							<span class="hidden md:inline">{{ labels.backbtn }}</span>
						</button>
					</div>
					<div class="flex">
							<LanguageSwitcher class="mr-3"  :languages="languageList" :hideLabel="false" />
							<PlayerButton
								v-if="( !collectionModeData?.hideReadittomeButton && post?.file_url) && (audienceContent.podcast && post?.activePodcast !== false)"
								:file_url="post?.file_url || ''"
								:isPlaying="playingId === post?.identifier"
								:language="requestedLng"
								:autoSuspend="false"
								@togglePlayback="handleTogglePlayback(post?.identifier ?? '')"
								class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
							/>
							<EditButton
								v-if="(collectionModeData?.editmode && post?.identifier && post?.file_url) && (audienceContent.podcast && post?.activePodcast !== false)"
								class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
								:id="post?.identifier"
								type="podcast"
								:overrideURL="post?._links.podcastSlideshowConversations?.href"
							/>

							<button
								class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 text-center font-sans text-xs font-bold transition-all bg-primary text-white ml-2"
								type="button"
								v-if="showPresentationHeaderButton"
								:class="{ 'rounded-e mr-2': !collectionModeData?.editmode }"
								@click="goToPresenation"
							>
								<i class="tabler:presentation w-5 h-5 mr-1"></i>

								<span class="hidden md:inline">{{ labels.presentation }}</span>
							</button>
							<EditButton
								v-if="(collectionModeData?.editmode && post?.identifier) && (audienceContent.presentation && post?.activePresentation !== false)"
								class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white mr-3"
								:id="post?.identifier"
								type="podcast"
								:overrideURL="post?._links.podcastSlideshow?.href"
							/>

						<button
							class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 text-center font-sans text-xs font-bold transition-all bg-primary text-white"
							:class="{ 'rounded-e mr-2': !collectionModeData?.editmode }"
							type="button"
							v-if="(!collectionModeData?.hidePostQuizButton && !showOnlyAssessment) && (audienceContent.postQuiz && post?.activePostQuiz !== false)"
							@click="modalVisiblePostQuiz = true"
						>
							<i class="tabler:list-details w-5 h-5 mr-1"></i>
							<span class="hidden md:inline">{{ labels.postquiz }}</span>
						</button>
						<EditButton
							v-if="(collectionModeData?.editmode && post?._links.postQuiz?.href && !showOnlyAssessment) && (audienceContent.postQuiz && post?.activePostQuiz !== false)"
							class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
							:id="post?.identifier ?? ''"
							:type="isLanguageReviewMode ? 'lngReviewEdit' : 'postquiz'"
							:overrideURL="post?._links.postQuiz?.href"
						/>
						<button
							class="rounded-s flex flex-row hover:bg-primary-500/80 items-center py-2 px-4 text-center font-sans text-xs font-bold transition-all bg-primary text-white ml-2"
							:class="{ 'rounded-e mr-2': !collectionModeData?.editmode }"
							type="button"
							v-if="audienceContent.assessment && post?.activeAssessment !== false && isAssessmentButtonEnabled && hasAssessmentQuiz"
							@click="modalVisibleAssessment = true"
						>
							<i class="tabler:clipboard-check w-5 h-5 mr-1"></i>
							<span class="hidden md:inline">{{ assessmentButtonLabel }}</span>
						</button>
						<EditButton
							v-if="audienceContent.assessment && post?.activeAssessment !== false && isAssessmentButtonEnabled && collectionModeData?.editmode && assessmentBaseUrl"
							class="rounded-e hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
							:id="post?.identifier ?? ''"
							:type="isLanguageReviewMode ? 'lngReviewEdit' : 'assessmentEdit'"
							:overrideURL="assessmentBaseUrl"
						/>

						<!-- <button
							class="flex flex-row hover:bg-primary-500/10 items-center rounded ml-2 py-2 px-4 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary text-white"
							type="button"
							@click="preparePrint"
						>
							<i class="tabler:printer w-5 h-5"></i
							><span class="hidden md:inline">{{ labels.prepareprint }}</span>
						</button> -->
						<!-- <EditButton
							class="flex flex-row hover:bg-primary-500/10 items-center rounded py-2 px-4 text-center font-sans mr-2 text-xs font-bold !hover:text-primary-500 transition-all bg-primary !text-white"
							v-if="collectionModeData?.editmode"
							:id="post?.identifier ?? ''"
							type="slideshow"
						/> -->

					</div>
				</div>
				<DialogModal v-if="isModalPreQuiz"
					v-model:visible="modalVisiblePreQuiz"
					modal
					:header="labels.prequiz"
					:style="{ width: '40rem' }"
					:breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
				>
					<EditButton
						v-if="(collectionModeData?.editmode) && (audienceContent.preQuiz && post?.activePreQuiz !== false)"
						class="absolute right-53px top-[20px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
						:id="post?.identifier ?? ''"
						type="prequiz"
						:overrideURL="post?._links.preQuiz?.href"
					/>
					<PreQuiz
						:jsonData="post"
						:overrideURL="preQuizUrl"
						:selectedLanguage="requestedLng"
						@close="modalVisiblePreQuiz = false"
					/>
				</DialogModal>
				<SliderPanel v-else
					v-model:visible="modalVisiblePreQuiz"
					:title="labels.prequiz"
					headerStyle="dark"
					size="xl"
					icon="tabler:list-check"
					:dismissable="false"
				>
					<div class="h-full overflow-y-auto p-4">
						<div v-if="collectionModeData?.editmode" class="mb-3 flex justify-end">
							<EditButton v-if="audienceContent.preQuiz && post?.activePreQuiz !== false"
								class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
								:id="post?.identifier ?? ''"
								type="prequiz"
								:overrideURL="post?._links.preQuiz?.href"
							/>
						</div>
						<PreQuiz
							:jsonData="post"
							:overrideURL="preQuizUrl"
							:selectedLanguage="requestedLng"
							@close="modalVisiblePreQuiz = false"
						/>
					</div>
				</SliderPanel>
				<DialogModal v-if="!showOnlyAssessment && isModalPostQuiz"
					v-model:visible="modalVisiblePostQuiz"
					modal
					:header="labels.postquiz"
					:style="{ width: '40rem' }"
					:breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
				>
					<EditButton
						v-if="(collectionModeData?.editmode) && (audienceContent.postQuiz && post?.activePostQuiz !== false)"
						class="absolute right-53px top-[20px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
						:id="post?.identifier ?? ''"
						:type="isLanguageReviewMode ? 'lngReviewEdit' : 'postquiz'"
						:overrideURL="post?._links.postQuiz.href"
					/>
					<PostQuiz :jsonData="post" @close="modalVisiblePostQuiz = false" />
				</DialogModal>
				<SliderPanel v-else-if="!showOnlyAssessment"
					v-model:visible="modalVisiblePostQuiz"
					:title="labels.postquiz"
					headerStyle="dark"
					size="xl"
					icon="tabler:list-check"
					:dismissable="false"
				>
					<div class="h-full overflow-y-auto p-4">
						<div v-if="collectionModeData?.editmode" class="mb-3 flex justify-end">
							<EditButton v-if="audienceContent.postQuiz && post?.activePostQuiz !== false"
								class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
								:id="post?.identifier ?? ''"
								:type="isLanguageReviewMode ? 'lngReviewEdit' : 'postquiz'"
								:overrideURL="post?._links.postQuiz.href"
							/>
						</div>
						<PostQuiz :jsonData="post" @close="modalVisiblePostQuiz = false" />
					</div>
				</SliderPanel>
				<DialogModal
					v-if="isAssessmentButtonEnabled && isModalAssessment"
					v-model:visible="modalVisibleAssessment"
					modal
					:header="assessmentButtonLabel"
					:style="{ width: '40rem' }"
					:breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
				>
					<EditButton
						v-if="(collectionModeData?.editmode && assessmentBaseUrl) && (audienceContent.assessment && post?.activeAssessment !== false)"
						class="absolute right-53px top-[20px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
						:id="post?.identifier ?? ''"
						:type="isLanguageReviewMode ? 'lngReviewEdit' : 'assessmentEdit'"
						:overrideURL="assessmentBaseUrl"
					/>
					<Assessment
						:jsonData="post"
						:overrideURL="assessmentQuizUrl"
						:collectionMode="collectionModeData?.id"
						:selectedLanguage="requestedLng"
						@close="modalVisibleAssessment = false"
					/>
				</DialogModal>
				<SliderPanel
					v-else-if="isAssessmentButtonEnabled"
					v-model:visible="modalVisibleAssessment"
					:title="assessmentButtonLabel"
					headerStyle="dark"
					size="xl"
					icon="tabler:clipboard-check"
					:dismissable="false"
				>
					<div class="h-full overflow-y-auto p-4">
						<div v-if="collectionModeData?.editmode && assessmentBaseUrl" class="mb-3 flex justify-end">
							<EditButton v-if="audienceContent.assessment && post?.activeAssessment !== false"
								class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
								:id="post?.identifier ?? ''"
								:type="isLanguageReviewMode ? 'lngReviewEdit' : 'assessmentEdit'"
								:overrideURL="assessmentBaseUrl"
							/>
						</div>
						<Assessment
							:jsonData="post"
							:overrideURL="assessmentQuizUrl"
							:collectionMode="collectionModeData?.id"
							:selectedLanguage="requestedLng"
							@close="modalVisibleAssessment = false"
						/>
					</div>
				</SliderPanel>

				<DialogModal group="templating">
					<template #message="slotProps">
						<div class="flex flex-col items-center w-full gap-3 border-b-1 pb-3">
							<div
								class="border-rounded-50% border-primary w-50px h-50px border-3px flex items-center justify-center"
							>
								<i :class="slotProps.message.icon" class="text-3xl inline-block text-primary-500"></i>
							</div>
							<p class="text-sm text-gray-700">{{ slotProps.message.message }}</p>
						</div>
					</template>
				</DialogModal>

				<!-- <DialogModal
                    v-model:visible="showQuiz"
                    maximizable
                    modal
                    header="Test your Knowledge"
                    :style="{ width: '90rem' }"
                    :breakpoints="{ '1199px': '75vw', '575px': '90vw' }"
                >
                    <PreQuiz @close="showQuiz = false" />
                </DialogModal> -->

				<div v-if="showDetailsContent">
					<EwLoadingOverlay v-if="loading" class="relative inset-0 z-50 flex items-center justify-center" />  
					<section id="section1" class="mb-8">
						<div class="flex justify-end p-3">
							<button v-if="post?.activeIllustrations !== false"
								type="button"
								class="flex flex-row items-center justify-center items-center text-center font-sans text-xs transition-all block md:hidden text-primary-500"
								@click="showGallery = !showGallery"
							>
								<i class="tabler:photo-up w-5 h-5"></i>
							</button>
						</div>

						<div class="flex flex-row sm:flex-column justify-center px-4 flex-wrap" v-if="post">
							<div id="twoCol" v-if="post?.mainOutcome?.sectionLayout != 'oneCol'" class="flex flex-row sm:flex-column justify-center flex-wrap">
							<div v-if="post?.activeIllustrations !== false" class="pr-4 sm:w-4/12 md:w-4/12 lg:w-4/12 rounded-lg hidden sm:block">
								<div class="flex items-center gap-2 justify-end mb-3">
									<EditButton
										class="rounded hover:bg-primary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary !text-white no-print"
										type="newImage"
										v-if="collectionModeData?.editmode"
										:id="post?.identifier ?? ''"
										:overrideURL="post?._links.illustration.href"
									/>
									<EditButton
										class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
										v-if="collectionModeData?.editmode"
										:id="post?.identifier ?? ''"
										type="imagelist"
										:overrideURL="post?._links.illustration.href"
									/>
								</div>

								<div v-if="post?.illustration && post.illustration.length != 0 && post.mainOutcome.sectionLayout != 'oneCol'" class="relative">
									<ImageGallery :jsonData="post" :collectionModeData="collectionModeData"></ImageGallery>
								</div>
								<div v-else>
									<InteractiveImage alt="Image" preview>
										<template #indicatoricon>
											<i class="tabler:eye w-8 h-8 text-white"></i>
										</template>
										<template #image>
												<img
													v-if="!isImageError"
													:src="post?.mainOutcome.imageSrc"
													alt="image"
													@load="isImageLoaded = true"
													@error="isImageError = true"
													class="transition-opacity duration-300 !max-h-[720px]"
													:class="{ 'opacity-0': !isImageLoaded }"
												/>

												<div v-if="isImageError" class="text-red-500 text-sm">Image not available</div>

										</template>
										<template #preview="slotProps">
											<div class="p-5">
												<img
													:src="post?.mainOutcome.imageSrc"
													alt="preview"
													class="mx-auto"
													:style="slotProps.style"
													@click="slotProps.onClick"
												/>
												<p class="text-sm italic text-white mt-8 text-left">
													{{ post?.mainOutcome.imageTitle }}
												</p>
											</div>
										</template>
									</InteractiveImage>
									<div class="text-left italic text-sm">
										{{ post?.mainOutcome.imageTitle }}
									</div>
								</div>
							</div>
							<div class="md:px-0 pb-2 sm:w-8/12 md:w-8/12 lg:w-8/12 flex-1">
							
								<div class="main-text relative">
										<EditButton
											v-if="collectionModeData?.editmode"
											class="absolute right-0 top-[-10px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
											:id="post?.identifier ?? ''"
											:overrideURL="post._links.mainOutcome.href"
											type="listattr"
										/>
										<InplaceEdit
											:inputProps="[{ content: post.mainOutcome.selectHeader,  propName: 'other.selectHeader', inputType: 'input' }]"
											:href="post._links.mainOutcomeEdit?.href" blockTitle="Edit header" :showAssistant="true" :collectionMode="collectionModeData">
											<h6
												class="my-2 !line-height-[1.2] font-sans md:text-md text-sm font-semibold text-primary-500 antialiased">
												{{ post.mainOutcome.selectHeader }}
											</h6>
										</InplaceEdit>
									<div class="flex items-center">
										<InplaceEdit
											:inputProps="[
												{
													content: post.mainOutcome.title,
													propName: 'title',
													inputType: 'textarea',
												},
											]"
											:href="post._links.mainOutcomeEdit.href"
											:showAssistant="true"
											:collectionMode="collectionModeData"
											blockTitle="Edit title"
											:textarea-props="{ rows: 3, class: 'min-w-[60rem]' }"
										>
											<h4
												class="my-2 !line-height-[1.2] flex items-center cursor-pointer font-sans md:text-xl text-lg font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased"
											>
												{{ post.mainOutcome.title }}
											</h4>
										</InplaceEdit>
									</div>
										<div class="gap-3 flex items-center">
											<InplaceEdit
												v-if="!isLanguageReviewMode"
												:collectionMode="collectionModeData"
												:inputProps="[
													{
														content: post.mainOutcome.publishingDate,
														propName: 'other.publishingDate',
														inputType: 'datepicker',
													},
												]"
												:href="post._links.mainOutcomeEdit.href"
												blockTitle="Edit publishing date"
											>
												<div class="text-sm inline-flex items-center pt-1 my-1">
													{{ publishingDateFormated }}
												</div>
											</InplaceEdit>
											<div v-else class="text-sm inline-flex items-center pt-1 my-1">
												{{ publishingDateFormated }}
											</div>
											<InplaceEdit
												:collectionMode="collectionModeData"
												v-if="!isLanguageReviewMode"
												:inputProps="[
													{
														content: post.mainOutcome.authorIdentifier,
														propName: 'other.authorIdentifier',
														inputType: 'select',
														selectProps: {
															optionValue: 'identifier',
															optionLabel: 'title',
															class: 'w-15rem',
															optionsCvKey: 'author',
														},
													},
												]"
												:href="post._links.mainOutcomeEdit.href"
												blockTitle="Edit author"
											>
												<div class="ml-2 text-sm font-bold" v-html="post.mainOutcome.author"></div>
											</InplaceEdit>
											<div v-else class="ml-2 text-sm font-bold" v-html="post.mainOutcome.author"></div>
										</div>
										<div v-if="post?.mainOutcome.leadText" class="relative py-3">
											<strong class="mb-4">{{ labels.leadText }}</strong>
											<div id="editLeadText" class="flex items-end relative">
												<InplaceEdit
													:collectionMode="collectionModeData"
													:enableCollapseSection="true"
													:extraContent="post?.mainOutcomeBl?.leadText"
													:inputProps="[{ content: post?.mainOutcome.leadText, propName: 'other.leadText', inputType: 'editor' }]"
													:href="post?._links?.mainOutcomeEdit?.href" blockTitle="Edit leadtext" :showAssistant="true">
													<div v-html="post?.mainOutcome.leadText"></div>
												</InplaceEdit>
											</div>
										</div>
										<div id="editKeyMessages" class="relative mt-3 py-4" v-if="post?.mainOutcome.keyMessages">
											<h3 class="font-bold text-md mb-4">{{ labels.keymessages }}</h3>
											<!-- <EditButton
												v-if="collectionModeData?.editmode && post.identifier"
												class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
												:id="post?.identifier ?? ''"
												:overrideURL="post._links.mainOutcome.href"
												type="references"
											/> -->

											<div class="shadow-sm border rounded-lg">
												<div class="flex justify-between items-center">
													<div class="sorces relative border-secondary w-full">
														<div id="editKeyMessagges" class="py-5 px-2">
															<InplaceEdit
																:collectionMode="collectionModeData"
																:inputProps="[{ content: post?.mainOutcome.keyMessages, propName: 'other.keyMessages', inputType: 'editor' }]"
																:href="post?._links.mainOutcomeEdit?.href" blockTitle="Edit key Messages" :showAssistant="true">
																<div v-html="post?.mainOutcome.keyMessages"></div>
															</InplaceEdit>
														</div>
													</div>
												</div>
											</div>
										</div>

										<div v-for="(section, index) in post.mainOutcome.main_text" :key="index">
											<InplaceEdit
												:collectionMode="collectionModeData"
												:inputProps="[
													{ content: section.heading, inputType: 'input', propName: 'heading' },
													{ content: section.content, inputType: 'editor', propName: 'content' },
												]"
												method="PUT"
												:href="section._links.self.href"
												blockTitle="Edit section"
												:showAssistant="true"
											>
												<div class="my-2">
													<div class="text-sm">
														<strong class="block">{{ section.heading }}</strong>
														<div v-html="section.content"></div>
													</div>
												</div>
											</InplaceEdit>
										</div>
									</div>
									<div v-if="post?.activeReferences !== false" class="relative mt-3 py-4">
										<h3 class="font-bold text-md mb-4">{{ labels.referenceslabel }}</h3>
										<EditButton
											v-if="collectionModeData?.editmode && post.identifier"
											class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
											:id="post?.identifier ?? ''"
											:overrideURL="post._links.mainOutcome.href"
											type="references"
										/>

										<div id="references" class="shadow-sm border rounded-lg">
											<div class="flex justify-between items-center">
												<div class="sorces relative border-secondary w-full">
													<div
														class="py-5 px-2 mx-4"
														v-if="
															post?.mainOutcome.references &&
															post.mainOutcome.references.length > 0
														"
													>
														<ol class="list-decimal">
															<li
																v-for="(referenceItem, index) in post?.mainOutcome
																	.references"
																:key="index"
																class="text-sm"
															>
															<div class="flex items-center py-1">
																	<InplaceEdit
																		:collectionMode="collectionModeData"
																		:inputProp="
																			{
																				content: referenceItem,
																				propName: 'other',
																				removeProps: ['pdfLink', '_links'],
																				inputType: 'references',
																			}
																		"
																		method="PATCH"
																		:href="referenceItem._links?.self.href"
																		:showSwitch="true"
																		blockTitle="Edit Refrence"
																	>
																	
																		<span v-if="referenceItem.journal">
																			{{ referenceItem.journal }}
																		</span>
																		<span v-if="referenceItem.year">
																			{{ referenceItem.year }},
																		</span>

																		<span
																			v-if="
																				referenceItem.nameDOI || referenceItem.linkDOI
																			"
																			class="font-semibold"
																		>
																			{{ referenceItem.nameDOI ? 'DOI:' : 'Link:' }}
																			<a
																				:href="
																					referenceItem.nameDOI
																						? `https://doi.org/${referenceItem.nameDOI}`
																						: referenceItem.linkDOI
																				"
																				target="_blank"
																				class="text-primary"
																			>
																				{{
																					referenceItem.nameDOI
																						? `${referenceItem.nameDOI}`
																						: referenceItem.linkDOI
																				}}
																			</a>
																		</span>
																		<span
																			v-if="
																				(referenceItem.nameDOI ||
																					referenceItem.linkDOI) &&
																				referenceItem.title
																			"
																			>,
																		</span>
																		<span
																			v-if="referenceItem.title"
																			class="ml-1 font-semibold"
																			>&laquo;{{ referenceItem.title }}&raquo;</span>
																	</InplaceEdit>
																	<a v-if="referenceItem?.pdfLink" @click.prevent="openModal(index)" class="btn btn-outline-dark px-1 py-0 cursor-pointer">
																		<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																	</a>
																	<!-- <a v-if="referenceItem?.pdfLink" @click="openModal" class="btn btn-outline-dark px-1 py-0 cursor-pointer"  		:href="`/example/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`">
																		<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																	</a> -->
																	<!-- <iframe class="pdfViewer w-100 h-100" style="" :src="`/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`"></iframe> -->

																</div>
															</li>
														</ol>
													</div>
													<div v-else class="p-5 bg-gray-100 flex items-center">
														<div class="text-center text-danger text-xs inline-flex mx-auto">
															<i class="tabler:info-triangle w-5 h-5 mr-2"></i>{{labels.noReference}}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

							</div>

							<div id="oneCol" v-else class="flex flex-wrap">
								<div class="flex flex-row sm:flex-column justify-center flex-wrap">
									<div v-if="post?.activeIllustrations !== false" class="pr-4 sm:w-3/12 md:w-3/12 lg:w-3/12 rounded-lg hidden sm:block">
										<div class="flex items-center gap-2 justify-end mb-3">
											<EditButton
												class="rounded hover:bg-primary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-primary-500 transition-all bg-primary !text-white no-print"
												type="newImage"
												v-if="collectionModeData?.editmode"
												:id="post?.identifier ?? ''"
												:overrideURL="post?._links.illustration.href"
											/>
											<EditButton
												class="rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
												v-if="collectionModeData?.editmode"
												:id="post?.identifier ?? ''"
												type="imagelist"
												:overrideURL="post?._links.illustration.href"
											/>
										</div>

										<div>
											<InteractiveImage alt="Image" preview>
												<template #indicatoricon>
													<i class="tabler:eye w-8 h-8 text-white"></i>
												</template>
												<template #image>
														<img
															v-if="!isImageError"
															:src="post?.mainOutcome.imageSrc"
															alt="image"
															@load="isImageLoaded = true"
															@error="isImageError = true"
															class="transition-opacity duration-300 !max-h-[500px] w-full object-cover"
															:class="{ 'opacity-0': !isImageLoaded }"
														/>

														<div v-if="isImageError" class="text-red-500 text-sm">Image not available</div>
												</template>
												<template #preview="slotProps">
													<div class="p-5">
														<img
															:src="post?.mainOutcome.imageSrc"
															alt="preview"
															class="mx-auto"
															:style="slotProps.style"
															@click="slotProps.onClick"
														/>
														<p class="text-sm italic text-white mt-8 text-left">
															{{ post?.mainOutcome.imageTitle }}
														</p>
													</div>
												</template>
											</InteractiveImage>
											<div class="text-left italic text-sm">
												{{ post?.mainOutcome.imageTitle }}
											</div>
										</div>
									</div>
									<div class="md:px-0 pb-2 sm:w-9/12 md:w-9/12 lg:w-9/12 flex-1">
										<InplaceEdit
											:inputProps="[{ content: post?.mainOutcome?.selectHeader,  propName: 'other.selectHeader', inputType: 'input' }]"
											:href="post?._links.mainOutcomeEdit?.href" blockTitle="Edit header" :showAssistant="true" :collectionMode="collectionModeData"
											:enableCollapseSection="true" :extraContent="post?.mainOutcomeBl.selectHeader">
											<h6
												class="my-2 !line-height-[1.2] font-sans md:text-md text-sm font-semibold text-primary-500 antialiased">
												{{ post?.mainOutcome.selectHeader }}
											</h6>
										</InplaceEdit>
										<div class="flex items-center">

													<InplaceEdit
														:inputProps="[
															{
																content: post?.mainOutcome.title,
																propName: 'title',
																inputType: 'textarea',
															},
														]"
														:href="post?._links.mainOutcomeEdit.href"
														:showAssistant="true"
														:enableCollapseSection="true"
														:extraContent="post?.mainOutcomeBl.title"
														:collectionMode="collectionModeData"
														blockTitle="Edit title"
														:textarea-props="{ rows: 3, class: 'min-w-[60rem]' }"
													>
														<h4
															class="my-2 !line-height-[1.2] flex items-center cursor-pointer font-sans md:text-xl text-lg font-semibold leading-snug tracking-normal text-blue-gray-900 antialiased"
														>
															{{ post?.mainOutcome.title }}
														</h4>
													</InplaceEdit>
										</div>
										<div class="gap-3 flex items-center">
											<InplaceEdit
												v-if="!isLanguageReviewMode"
												:collectionMode="collectionModeData"
												:inputProps="[
													{
														content: post?.mainOutcome.publishingDate,
														propName: 'other.publishingDate',
														inputType: 'datepicker',
													},
												]"
												:href="post?._links.mainOutcomeEdit.href"
												blockTitle="Edit publishing date"
											>
												<div class="text-sm inline-flex items-center pt-1 my-1">
													{{ publishingDateFormated }}
												</div>
											</InplaceEdit>
											<div v-else class="text-sm inline-flex items-center pt-1 my-1">
												{{ publishingDateFormated }}
											</div>

											<InplaceEdit
												:collectionMode="collectionModeData"
												v-if="!isLanguageReviewMode"
												:inputProps="[
													{
														content: post?.mainOutcome.authorIdentifier,
														propName: 'other.authorIdentifier',
														inputType: 'select',
														selectProps: {
															optionValue: 'identifier',
															optionLabel: 'title',
															class: 'w-15rem',
															optionsCvKey: 'author',
														},
													},
												]"
												:href="post?._links?.mainOutcomeEdit?.href || ''"
												blockTitle="Edit author"
											>
												<div class="ml-2 text-sm font-bold" v-html="post?.mainOutcome.author"></div>
											</InplaceEdit>
											<div v-else class="ml-2 text-sm font-bold" v-html="post?.mainOutcome.author"></div>
										</div>
										<div v-if="post?.mainOutcome.leadText" class="relative py-3">
											<strong class="mb-4">{{ labels.leadText }}</strong>
											<div id="editLeadText" class="flex items-end relative">
												<InplaceEdit
													:collectionMode="collectionModeData"
													:enableCollapseSection="true"
													:extraContent="post?.mainOutcomeBl.leadText"
													:inputProps="[{ content: post?.mainOutcome.leadText, propName: 'other.leadText', inputType: 'editor' }]"
													:href="post?._links?.mainOutcomeEdit?.href" blockTitle="Edit leadtext" :showAssistant="true">
													<div v-html="post?.mainOutcome.leadText"></div>
												</InplaceEdit>
											</div>
										</div>
									<div id="editKeyMessages" class="relative py-4" v-if="post?.mainOutcome.keyMessages">
										<h3 class="font-bold text-md mb-4">{{ labels.keymessages }}</h3>
										<!-- <EditButton
											v-if="collectionModeData?.editmode && post.identifier"
											class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white"
											:id="post?.identifier ?? ''"
											:overrideURL="post._links.mainOutcome.href"
											type="references"
										/> -->

										<div class="shadow-sm border rounded-lg">
											<div class="flex justify-between items-center">
												<div class="sorces relative border-secondary w-full">
													<div id="editKeyMessagges" class="py-5 px-2">
														<InplaceEdit
															:collectionMode="collectionModeData"
															:enableCollapseSection="true"
															:extraContent="post?.mainOutcomeBl.keyMessages"
															:inputProps="[{ content: post?.mainOutcome.keyMessages, propName: 'other.keyMessages', inputType: 'editor' }]"
															:href="post?._links?.mainOutcomeEdit?.href" blockTitle="Edit key Messages" :showAssistant="true">
															<div v-html="post?.mainOutcome.keyMessages"></div>
														</InplaceEdit>
													</div>
												</div>
											</div>
										</div>
									</div>

									</div>	
								</div>							
								<div :class="sectionLayoutClass">
									<div class="main-text relative">
										<div v-for="(section, index) in post?.mainOutcome.main_text" :key="index" >
											<InplaceEdit
												:collectionMode="collectionModeData"
												:enableCollapseSection="true"
												:extraContent="[
													post?.mainOutcomeBl?.main_text?.[index]?.heading ?? '',
													post?.mainOutcomeBl?.main_text?.[index]?.content ?? ''
												]"
												:inputProps="[
													{ content: section.heading, inputType: 'input', propName: 'heading' },
													{ content: section.content, inputType: 'editor', propName: 'content' },
												]"
												method="PUT"
												:href="section._links.self.href"
												blockTitle="Edit section"
												:showAssistant="true"
											>
												<div class="my-2">
													<div class="text-sm">
														<strong class="block text-gray-700">
															{{ section.heading }}
														</strong>
														<div v-html="section.content" class="text-gray-600"></div>
													</div>
												</div>
											</InplaceEdit>
											<div v-if="post?.activeIllustrations !== false" class="flex w-full flex-col">
												<template v-for="(illustrationGroup, illGroupIndex) in (section.illustrations as any[])" :key="illGroupIndex">
													<template v-for="(illustration, illIndex) in (illustrationGroup as any[])" :key="illIndex">
														<div v-if="(illustration as any)?.imageSrc" class="flex align-items-center gap-4 my-4">
															<InteractiveImage class="w-[270px] overflow-hidden" alt="Image" preview>
																<template #indicatoricon>
																	<i class="tabler:eye w-8 h-8 text-white"></i>
																</template>

																<template #image>
																	<img
																		v-if="(illustration as any).imageSrc && (illustration as any).imageSrc !== '' && !isImageError"
																		:src="(illustration as any).imageSrc"
																		alt="image"
																		@load="isImageLoaded = true"
																		@error="isImageError = true"
																		class="transition-opacity duration-300 w-full h-auto max-w-[270px] object-contain"
																		:class="{ 'opacity-0': !isImageLoaded }"
																	/>
																	<div v-else class="text-gray-400 italic text-sm">No image available</div>
																</template>

																<template #preview="slotProps">
																	<div class="p-5">
																		<img
																			v-if="(illustration as any).imageSrc && (illustration as any).imageSrc !== ''"
																			:src="(illustration as any).imageSrc"
																			alt="preview"
																			class="mx-auto"
																			:style="slotProps.style"
																			@click="slotProps.onClick"
																		/>
																		<p class="text-sm italic text-white mt-8 text-left">
																			{{ (illustration as any).imageTitle || '' }}
																		</p>
																	</div>
																</template>
															</InteractiveImage>
															<div class="rounded bg-primary-50/20 p-3 flex flex-col gap-2 flex-1">
																<div class="text-left text-sm">
																	<strong>{{labels.titleLabel}}</strong> {{ (illustration as any).imageTitle || '' }}
																</div>
																<div class="text-left text-sm">
																	<strong>{{labels.descriptionLabel}}</strong> {{ (illustration as any).imageDescription || '' }}
																</div>
																<div class="text-left text-sm">
																	<strong>{{labels.copyrightLabel}}</strong> {{ (illustration as any).imageCopyright || '' }}
																</div>
															</div>
														</div>
													</template>
												</template>
											</div>
										</div>
									</div>
									<div class="relative mt-3 py-4" v-if="(post?.mainOutcome.references && post.mainOutcome.references.length > 0) && (post?.activeReferences !== false)" >
										<h3 class="font-bold text-md mb-4">{{ labels.referenceslabel }}</h3>
										<!-- <EditButton
											v-if="collectionModeData?.editmode && !isLanguageReviewMode"
											class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-2 px-3 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all bg-secondary !text-white no-print"
											:id="post?.identifier ?? ''"
											:overrideURL="post._links.mainOutcome.href"
											type="references"
										/> -->

										<div id="references" class="shadow-sm border rounded-lg">
											<div class="flex justify-between items-center">
												<div class="sorces relative border-secondary w-full">
													<div
														class="py-5 px-2 mx-4"
													>
														<ol class="list-decimal">
															<li
																v-for="(referenceItem, index) in post?.mainOutcome
																	.references"
																:key="index"
																class="text-sm"
															>
															<div class="flex items-center py-1">
																	<InplaceEdit
																		:collectionMode="collectionModeData"
																		:inputProp="
																			{
																				content: referenceItem,
																				propName: 'other',
																				removeProps: ['pdfLink', '_links'],
																				inputType: 'references',
																			}
																		"
																		method="PUT"
																		:href="referenceItem._links?.self.href"
																		:showSwitch="true"
																		blockTitle="Edit Refrence"
																	>
																	
																		<span v-if="referenceItem.journal">
																			{{ referenceItem.journal }}
																		</span>
																		<span v-if="referenceItem.year">
																			{{ referenceItem.year }},
																		</span>

																		<span
																			v-if="
																				referenceItem.nameDOI || referenceItem.linkDOI
																			"
																			class="font-semibold"
																		>
																			{{ referenceItem.nameDOI ? 'DOI:' : 'Link:' }}
																			<a
																				:href="
																					referenceItem.nameDOI
																						? `https://doi.org/${referenceItem.nameDOI}`
																						: referenceItem.linkDOI
																				"
																				target="_blank"
																				class="text-primary"
																			>
																				{{
																					referenceItem.nameDOI
																						? `${referenceItem.nameDOI}`
																						: referenceItem.linkDOI
																				}}
																			</a>
																		</span>
																		<span
																			v-if="
																				(referenceItem.nameDOI ||
																					referenceItem.linkDOI) &&
																				referenceItem.title
																			"
																			>,
																		</span>
																		<span
																			v-if="referenceItem.title"
																			class="ml-1 font-semibold"
																			>&laquo;{{ referenceItem.title }}&raquo;</span>
																	</InplaceEdit>
																	<a v-if="referenceItem?.pdfLink" @click.prevent="openModal(index)" class="btn btn-outline-dark px-1 py-0 cursor-pointer no-print">
																		<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																	</a>
																	<!-- <a v-if="referenceItem?.pdfLink" @click="openModal" class="btn btn-outline-dark px-1 py-0 cursor-pointer"  		:href="`/example/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`">
																		<i class="tabler:pdf text-lg text-danger inline-flex ml-auto"></i>
																	</a> -->
																	<!-- <iframe class="pdfViewer w-100 h-100" style="" :src="`/pdfjs/web/viewer.html?file=${referenceItem?.pdfLink}`"></iframe> -->

																</div>
															</li>
														</ol>
													</div>
													<!-- <div v-else class="p-5 bg-gray-100 flex items-center">
														<div class="text-center text-danger text-xs inline-flex mx-auto">
															<i class="tabler:info-triangle w-5 h-5 mr-2"></i>{{labels.noReference}}
														</div>
													</div> -->
												</div>
											</div>
										</div>
									</div>
									<div class="audio-player relative no-print ml-auto">
										<EditButton
											v-if="(collectionModeData?.editmode && !isLanguageReviewMode && post?.file_url) && (audienceContent.podcast && post?.activePodcast !== false)"
											class="absolute right-0 top-[0px] rounded hover:bg-secondary-500/80 items-center py-1 px-1 text-center font-sans text-xs font-bold hover:text-secondary-500 transition-all text-secondary !hover:text-white no-print z-2"
											:id="post?.identifier ?? ''"
											type="podcast"
											:overrideURL="post?._links?.podcastSlideshowConversations?.href"
										/>
										<SmallSoundPlayer v-if="audienceContent.podcast && post && post?.file_url" :jsonData="post" :language="selectedLanguage" :autoSuspend="false"
										/>
									</div>

									<!-- <div class="relative no-print">
										<RatingItems :jsonData="post" :feedback-url="computedFeedbackUrl" :selectedLanguage="currentLng" @open-postquiz="modalVisiblePostQuiz = true" :collectionMode="collectionModeData" />
									</div> -->
								</div>
							</div>
							</div>
					</section>
				</div>
			</div>
		</div>
	</div>
	<router-view v-slot="{ Component, route }">
		<component :is="Component" :selectedLanguage="currentLng" :id="route.params.id" v-bind="presentationDataDetails"/>
  	</router-view>


</template>

<script setup lang="ts">
import { getStudyClassificationParams } from '@/utils/studyClassificationParams';
import { getAudienceContentVisibility } from '@/utils/audienceContentVisibility';
import { ref, nextTick } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useEventBus } from '@vueuse/core';
import axios from 'axios'
import ImageGallery from '../components/ImageGallery.vue';
import LanguageSwitcher from '../components/LanguageSwitcher.vue';
import PlayerButton from '../components/PlayerButton.vue';
import PreQuiz from '../components/PreQuiz.vue';
import Assessment from '../components/Assessment.vue';
import PostQuiz from '../components/PostQuiz.vue';
import EditButton from '../components/EditButton.vue';
import SliderPanel from '@/components/SidebarPanel/SidebarPanel.vue'
import { useAppConfig } from '@/composables/useAppConfig';
import { messages } from '@/assets/language';
import type { configCollectionMode, CVResponse, Post, PostDetailsResponse } from '@/types';
import { DateTime } from 'luxon';
import InplaceEdit from '@/components/InplaceEdit/InplaceEdit.vue';
import { CVDataProvided } from '@/types/cvTypes';
import { useAppStore } from '@/stores/app-store'
import EwLoadingOverlay from '@/components/EwLoadingOverlay.vue';
import { resolveAssessmentButtonLabel } from '@/utils/assessmentLabel';
import { decodePostHtmlContent } from '@/utils/htmlContent';

const isImageLoaded = ref(false);
const isImageError = ref(false);
const loading = ref( false );



const route = useRoute();
const router = useRouter();
const bus = useEventBus<Record<string, any>>('saved');
const { currentLng, currentCollectionMode, 	currentTestyourself, currentPAGE_REQ_ID, currentStudyType, currentstudyMode } = useAppStore()

const AppConfig = useAppConfig();
watch([currentLng, () => route.query.lng], ()=>{
	fetchDataPost()
})

function onPropSaved(event: Record<string, any>) {
	console.log(event);
	fetchDataPost();
}
const unsubscribe = bus.on(onPropSaved);

const CVData = ref<CVResponse>({ data: {} });
provide(CVDataProvided, CVData);

// const selectedLanguage = computed( () => ( route.query.lng ) );
const labels = computed( () => {
	const key = currentLng.value as keyof typeof messages
	return messages[key] ?? {}
});
const assessmentButtonLabel = computed(() =>
	resolveAssessmentButtonLabel({
		typeOfOutcome: AppConfig.urls.assessment?.typeofoutcome,
		configuredLabel: AppConfig.urls.assessment?.buttonLabel,
		labels: labels.value
	})
);

const props = defineProps<{
  selectedLanguage?: string;
}>();


const postId = route.params.id as string;

const post = ref<Post | null>(null);
const audienceContent = computed(() => getAudienceContentVisibility(
 post.value, AppConfig.collectionMode ?? collectionModeData.value?.id
));
const detailsContent = ref<HTMLElement | null>(null);
const collectionModeData = ref<configCollectionMode | null>(null);
const sectionLayoutClass = computed(() => {
	const layout = post.value?.mainOutcome?.sectionLayout;

	if (layout === 'oneCol') {
		return 'md:px-0 pb-2 sm:w-12/12 md:w-12/12 lg:w-12/12 flex-1';
	}
	if (layout === 'twoCol') {
		return 'md:px-0 pb-2 sm:w-8/12 md:w-8/12 lg:w-8/12 flex-1';
	}

	return 'md:px-0 pb-2 sm:w-12/12 md:w-12/12 lg:w-12/12 flex-1';
});


//const jsonData = ref<Post | null>( null );
const modalVisiblePreQuiz = ref(false);
const modalVisibleAssessment = ref(false);
const modalVisiblePostQuiz = ref(false);
const isModalPreQuiz = computed(() => AppConfig.urls.keymessage?.modal === true)
const isModalAssessment = computed(() => AppConfig.urls.assessment?.modal === true)
const isModalPostQuiz = computed(() => AppConfig.urls.keymessage?.modal === true)
const isEnabledFlag = (value: unknown): boolean =>
	['y', 'yes', 'true', '1'].includes(String(value ?? '').trim().toLowerCase())
const isAssessmentButtonEnabled = computed(() =>
	isEnabledFlag(AppConfig.urls.assessment?.enabled)
)
const isLanguageReviewMode = computed(() => {
	const mode = String(collectionModeData.value?.id ?? '')
		.trim()
		.toLowerCase()
		.replace(/[^a-z0-9]+/g, '_')

	return ['language_review'].includes(mode)
})
const showOnlyAssessment = computed(() =>
	isEnabledFlag(collectionModeData.value?.showOnlyAssessment) ||
	isEnabledFlag(AppConfig.showOnlyAssessment)
)
const showOnlyPostQuiz = computed(() =>
	!showOnlyAssessment.value && (
		isEnabledFlag(currentTestyourself.value) ||
		isEnabledFlag(collectionModeData.value?.showOnlyPostquiz) ||
		isEnabledFlag(AppConfig.showOnlyPostquiz)
	)
)

const showGallery = ref(false);

const getFirstQueryString = (value: unknown): string => {
	if (typeof value === 'string') {
		return value.trim();
	}
	if (Array.isArray(value)) {
		const firstString = value.find((entry) => typeof entry === 'string' && entry.trim().length > 0);
		return typeof firstString === 'string' ? firstString.trim() : '';
	}
	return '';
};

const requestedLng = computed(() => {
	const lngFromRoute = getFirstQueryString(route.query.lng);
	if (lngFromRoute) {
		return lngFromRoute;
	}
	const lngFromProps = String(props.selectedLanguage ?? '').trim();
	if (lngFromProps) {
		return lngFromProps;
	}
	const lngFromStore = String(currentLng.value ?? '').trim();
	if (lngFromStore) {
		return lngFromStore;
	}
	return String(AppConfig.defaultLng ?? 'en').trim();
});

const hideDetailsHeaderInEmbeddedModal = computed(() => getFirstQueryString(route.query.embedded) === '1');

const syncRequestedLanguageContext = async () => {
	const resolvedLng = String(requestedLng.value ?? '').trim();
	if (!resolvedLng) {
		return;
	}

	const routeLng = getFirstQueryString(route.query.lng);
	if (!routeLng) {
		await router.replace({
			query: {
				...route.query,
				lng: resolvedLng,
			},
		});
		return;
	}

	if (String(currentLng.value ?? '').trim() !== resolvedLng) {
		currentLng.value = resolvedLng as any;
	}
};

watch(requestedLng, () => {
	void syncRequestedLanguageContext();
}, { immediate: true });

const preQuizUrl = computed(() => {
	const baseUrl = post.value?._links?.preQuiz?.href ?? ''
	if (!baseUrl) return ''
	const id = post.value?.identifier ?? ''
	const packageLng = requestedLng.value ?? ''
	const sourcereqid = AppConfig.PAGE_REQ_ID ?? ''
	const separator = baseUrl.includes('?') ? '&' : '?'
	return `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

const assessmentBaseUrl = computed(() => {
	const links = (post.value as any)?._links ?? {}
	return String(
		links?.assessmentQuiz?.href ??
		links?.assessment?.href ??
		links?.preQuizAssesment?.href ??
		links?.preQuizAssessment?.href ??
		''
	).trim()
})

const hasAssessmentQuiz = computed(() => {
	const questions = (post.value as any)?.assessmentQuiz?.questions
	return assessmentBaseUrl.value !== '' || (Array.isArray(questions) && questions.length > 0)
})

const assessmentQuizUrl = computed(() => {
	const baseUrl = assessmentBaseUrl.value
	if (!baseUrl) return ''
	const id = post.value?.identifier ?? ''
	const packageLng = requestedLng.value ?? ''
	const sourcereqid = AppConfig.PAGE_REQ_ID ?? ''
	const separator = baseUrl.includes('?') ? '&' : '?'
	return `${baseUrl}${separator}package=SAT&packageid=${id}&packageLng=${packageLng}&sourcereqid=${sourcereqid}`
})

const openTarget = computed(() => getFirstQueryString(route.query.open).toLowerCase())

const clearOpenActionQuery = async () => {
	if (!('open' in route.query)) {
		return
	}
	const query = { ...route.query }
	delete query.open
	await router.replace({ query })
}

const handleOpenTargetFromRoute = async () => {
	if (!post.value || !openTarget.value) {
		return
	}

	await nextTick()

	if (openTarget.value === 'prequiz') {
		modalVisiblePreQuiz.value = true
		await clearOpenActionQuery()
		return
	}

	if (openTarget.value === 'postquiz') {
		modalVisiblePostQuiz.value = true
		await clearOpenActionQuery()
		return
	}

	if (openTarget.value === 'assessment') {
		modalVisibleAssessment.value = true
		await clearOpenActionQuery()
		return
	}

	if (openTarget.value === 'keymessage') {
		const keyMessageElement = document.getElementById('editKeyMessages')
		keyMessageElement?.scrollIntoView({ behavior: 'smooth', block: 'start' })
		await clearOpenActionQuery()
	}
}

watch([openTarget, post], () => {
	void handleOpenTargetFromRoute()
}, { immediate: true })

function goToPresenation () {
	const nextQuery = { ...route.query }
	if (!nextQuery.returnTo && typeof window !== 'undefined') {
		nextQuery.returnTo = window.location.href
	}

	router.push({
		name: 'details-presenation',
		query: {
			...nextQuery,
			lng: requestedLng.value
		}
	});
}

const presentationDataDetails = computed(() => {
	if(route.name === 'details-presenation' && route.params.id) {
		return post.value ? { viewUrl: post.value._links.podcastSlideshowEdit?.href, editUrl: post.value._links.podcastSlideshow?.href} : null
	}
	return null
})

const isDetailsRoute = computed(() => route.name === 'details')
const isDetailsPresentationRoute = computed(() => route.name === 'details-presenation')
const showPresentationHeaderButton = computed(() =>
	audienceContent.value.presentation && post.value?.activePresentation !== false &&
	!collectionModeData.value?.hidePresentationButton && !isDetailsPresentationRoute.value
)
const showDetailsShell = computed(() => isDetailsRoute.value || isDetailsPresentationRoute.value)
const showDetailsContent = computed(() => isDetailsRoute.value)

const languageList = computed(() => CVData.value?.data?.language ?? []);


const publishingDateFormated = computed(() => {
	const publishingDate = post.value?.mainOutcome.publishingDate;
	const options: Intl.DateTimeFormatOptions = {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	};
	const formatDate = (date: Date) => {
		return new Intl.DateTimeFormat('en-GB', options).format(date);
	};
	if (!publishingDate) {
		return formatDate(new Date());
	}
	const dateTime = DateTime.fromISO(publishingDate);
	if (!dateTime.isValid) {
		return formatDate(new Date());
	}
	return formatDate(dateTime.toJSDate());
});

const openModal = (index: number) => {
  // Merr PDF linkun bazuar në index
  const pdfLink = post.value?.mainOutcome.references[index]?.pdfLink;

  if (!pdfLink) {
    console.error('PDF Link is not available.');
    return;
  }

  // Ndërto URL-në për iframe
  const viewerUrl = `/example/pdfjs/web/viewer.html?file=${encodeURIComponent(pdfLink)}`;

  // Hap modalin duke përdorur Bootstrap API
  const modal = new bootstrap.Modal(document.getElementById('pdfViewer') as HTMLElement);
  modal.show();

  // Vendos URL-në në iframe
  const iframe = document.getElementById('pdfIframe') as HTMLIFrameElement;
  if (iframe) {
    iframe.src = viewerUrl; // Vendos URL-në e ndërtuar
  }
};

const getLngFromIllustrationUrl = (rawUrl: string | null | undefined): string => {
	const value = String(rawUrl ?? '').trim();
	if (!value) {
		return '';
	}

	try {
		const url = new URL(value, window.location.origin);
		return String(url.searchParams.get('lng') ?? '').trim().toLowerCase();
	} catch {
		const match = value.match(/[?&]lng=([^&#]+)/i)?.[1] ?? '';
		if (!match) {
			return '';
		}
		try {
			return decodeURIComponent(match).trim().toLowerCase();
		} catch {
			return match.trim().toLowerCase();
		}
	}
};

const filterIllustrationsByLng = (illustrations: any[] | undefined, lng: string): any[] => {
	if (!Array.isArray(illustrations) || !lng) {
		return [];
	}

	const normalizedLng = lng.trim().toLowerCase();
	if (!normalizedLng) {
		return [];
	}

	const parsed = illustrations.map((item) => {
		const lngFromEdit = getLngFromIllustrationUrl(item?.imageSrcEdit);
		const lngFromSrc = getLngFromIllustrationUrl(item?.imageSrc);
		const itemLng = lngFromEdit || lngFromSrc;
		return { item, itemLng };
	});

	const hasLanguageTaggedItems = parsed.some(({ itemLng }) => Boolean(itemLng));
	if (!hasLanguageTaggedItems) {
		return illustrations;
	}

	const matching = parsed.filter(({ itemLng }) => itemLng === normalizedLng).map(({ item }) => item);
	if (matching.length === 0) {
		return [];
	}

	return parsed
		.filter(({ itemLng }) => itemLng === normalizedLng || !itemLng)
		.map(({ item }) => item);
};

const canonicalizeImageUrl = (rawUrl: string | null | undefined): string => {
	const value = String(rawUrl ?? '').trim();
	if (!value) {
		return '';
	}

	try {
		const url = new URL(value, window.location.origin);
		return `${url.origin}${url.pathname}`;
	} catch {
		return value.split(/[?#]/)[0]?.trim() ?? '';
	}
};

const collectIllustrationObjects = (value: unknown, output: Record<string, any>[]) => {
	if (Array.isArray(value)) {
		value.forEach((entry) => collectIllustrationObjects(entry, output));
		return;
	}

	if (!value || typeof value !== 'object') {
		return;
	}

	const candidate = value as Record<string, any>;
	if (typeof candidate.imageSrc === 'string' || typeof candidate.imageSrcEdit === 'string') {
		output.push(candidate);
	}

	if ('illustrations' in candidate) {
		collectIllustrationObjects(candidate.illustrations, output);
	}
};

const buildIllustrationsFromMainText = (mainText: unknown): any[] => {
	const collected: Record<string, any>[] = [];
	collectIllustrationObjects(mainText, collected);

	if (collected.length === 0) {
		return [];
	}

	const deduped = new Map<string, Record<string, any>>();
	collected.forEach((item, index) => {
		const key =
			canonicalizeImageUrl(item?.imageSrc) ||
			canonicalizeImageUrl(item?.imageSrcEdit) ||
			`fallback-${index}`;
		if (!deduped.has(key)) {
			deduped.set(key, item);
		}
	});

	return Array.from(deduped.values());
};

const getWiItemIdFromHref = (href: string | null | undefined): string | null => {
	if (!href) {
		return null;
	}
	const match = href.match(/\/wi-item\/([^/?#]+)/i);
	return match?.[1] ?? null;
};

const filterItemsByOutcomeId = <T extends Record<string, any>>(items: T[] | undefined, outcomeId: string | null): T[] => {
	if (!Array.isArray(items) || !outcomeId) {
		return Array.isArray(items) ? items : [];
	}
	return items.filter((item) => {
		const href = String(item?._links?.self?.href ?? '');
		if (!href) {
			return false;
		}
		return href.includes(`/wi-item/${outcomeId}/`);
	});
};

const normalizePostIllustrations = (candidate: Post | null): Post | null => {
	if (!candidate) {
		return null;
	}
	const selectedLng = String(requestedLng.value ?? '').trim();
	const desiredOutcomeHref = String((candidate as any)?._links?.languages?.[selectedLng]?.mainOutcome?.href ?? '').trim();
	const desiredOutcomeId =
		getWiItemIdFromHref(desiredOutcomeHref) ||
		String((candidate as any)?.mainOutcome?.id ?? '').trim() ||
		null;
	const baseMainText = (candidate as any)?.mainOutcome?.main_text;
	const filteredMainText = desiredOutcomeId ? filterItemsByOutcomeId(baseMainText, desiredOutcomeId) : [];
	const effectiveMainText = filteredMainText.length > 0 ? filteredMainText : baseMainText;
	const illustrationFromMainText = buildIllustrationsFromMainText(effectiveMainText);
	const topLevelIllustration = Array.isArray((candidate as any).illustration) ? (candidate as any).illustration : [];
	const sourceIllustration = illustrationFromMainText.length > 0 ? illustrationFromMainText : topLevelIllustration;
	const filteredIllustration = filterIllustrationsByLng(sourceIllustration, selectedLng);
	return decodePostHtmlContent({
		...candidate,
		mainOutcome: {
			...(candidate as any).mainOutcome,
			main_text: effectiveMainText
		},
		illustration: filteredIllustration
	} as Post);
};


onBeforeUnmount(() => {
	unsubscribe();
});

const fetchDataPost = async () => {
  try {
    loading.value = true;


		const queryWithoutOpen = { ...route.query }
		delete queryWithoutOpen.open
		delete queryWithoutOpen.returnTo
		delete queryWithoutOpen.studyMode
		delete queryWithoutOpen.studyTpe
		delete queryWithoutOpen.currentStudyType

		let params: Record<string, any> = {
			...queryWithoutOpen,
			...getStudyClassificationParams(currentStudyType.value, currentstudyMode.value),
			lng: requestedLng.value,
			'collection-mode': currentCollectionMode.value,
			testYourself: currentTestyourself.value,
			PAGE_REQ_ID: currentPAGE_REQ_ID.value,
		};

		const response = await axios.get<PostDetailsResponse>( `${AppConfig.urls.getList}?json=y`, {
			params,
			headers: {
				'Content-Type': 'application/json',
				'Accept-Language': requestedLng.value
			}
		} );


    post.value = normalizePostIllustrations(response.data.data.find((p) => p.identifier === postId) || null);
    CVData.value = response.data.CV;
    collectionModeData.value = response.data.config ?? null;
	console.log('Details Collection Mode', collectionModeData.value)


  } catch (error) {
    console.error('Failed to fetch data:', error);
  } finally {
    loading.value = false;
  }
};




const getReturnToUrl = () => {
	const returnTo = getFirstQueryString(route.query.returnTo)
	if (!returnTo) {
		return ''
	}

	try {
		return decodeURIComponent(returnTo)
	} catch {
		return returnTo
	}
}

const buildListQuery = () => {
	const query = { ...route.query }
	delete query.open
	delete query.embedded
	delete query.returnTo
	return query
}

const handleBackButtonClick = () => {
	if (getFirstQueryString(route.query.embedded) === '1' && window.parent && window.parent !== window) {
		window.parent.postMessage({ action: 'close-and-refresh' }, '*')
		return
	}

	const returnToUrl = getReturnToUrl()
	if (returnToUrl) {
		window.location.href = returnToUrl
		return
	}

	router.push({
		name: 'list',
		query: buildListQuery()
	})
};


const playingId = ref<string | null>(null);

const handleTogglePlayback = (identifier: string) => {
	playingId.value = playingId.value === identifier ? null : identifier;
};

	fetchDataPost();
	loading.value = true;


</script>

<style>
.p-image-action {
	background: #fff;
	margin: 0 10px;
}

#detailsContent ul,
#detailsContent ol {
	list-style: disc;
	margin: 0 25px;
	padding: 0 15px;
}

#detailsContent ol {
	list-style: decimal;
}

#detailsContent table {
	display: block;
	width: 100%;
	max-width: 100%;
	margin: 0.75rem 0 1rem;
	overflow-x: auto;
	border-collapse: collapse;
	font-size: 0.92em;
}

#detailsContent th,
#detailsContent td {
	border: 1px solid #d6deea;
	padding: 0.45rem 0.55rem;
	vertical-align: top;
}

#detailsContent th {
	background: #f6f8fc;
	font-weight: 700;
}

#detailsContent #references ol{
	padding:0!important;
	margin:0!important;
}
:deep(.compact-language .p-dropdown-label) {
	padding-right: 0.5rem !important;
	padding-left: 0.25rem !important;
	min-width: auto !important;
}

:deep(.compact-language .fi) {
	margin-right: 0 !important;
}


</style>
